<template name="countdownTimer">

    <span class="countdown" :style="{'color':color}">
        <span v-if="days > 0">{{days}} days</span> {{hours}}:{{minutes}}<span v-if="seconds">:{{seconds}}</span>
  

    </span>

</template>

<script>

    import moment from 'moment';

    export default {
        props: ['date','ongoing','duration','fast','isForMeeting'],
        data() {
            return {
                days:null,
                hours: null,
                minutes: null,
                seconds: null,
                color:null,
            }
        },
        mounted() {
                var self = this;

                var timing = 12000;

                if (this.fast === true) timing = 1000;

                var interval;              
                

                var countdown = function() {
                 
                    function pad(value) {
                      return ('00' + value).slice(-2);
                    }

                    var d = new Date(self.date);

                    var today = moment();


                    var diff = moment(d).diff(today, 'milliseconds');

                    var seconds = diff / 1000,
                        minutes = seconds / 60,
                        hours = minutes / 60,
                        days = hours / 24;

                    if (seconds <= 0) {
                        if (self.isForMeeting === true) {
                            self.$bus.$emit('meeting_started');
                        }
                        clearInterval(interval);                       
                    }

                    var color;

                    if (seconds < 21600) {
                        self.color = 'red';
                    } else if (seconds < 86400) {
                        self.color = 'yellow';
                    } else {
                        self.color = '#3feb9b';
                    }

                    days = parseInt(days),
                      hours = parseInt(hours % 24),
                      minutes = parseInt(minutes % 60),
                      seconds = parseInt(seconds % 60);


                    days !== 0 ? self.days = days : self.days = null;

                    self.hours = pad(Math.abs(hours));
                    self.minutes = pad(Math.abs(minutes));

                    if (hours <  1) {
                        self.seconds = pad(Math.abs(seconds));
                    }

                }
                countdown();

                interval = setInterval(countdown, timing);
        },

    }
</script>

<style lang="scss" scoped>
span.countdown > span {
    display: inline!important;
}

span {
    //font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// CountdownTimer.vue?4876ab13